$('.extra-info').bind('click', function (event) {
    if ($(event.target).siblings('.tooltip-container').hasClass('hidden')) {
        $(event.target).siblings('.tooltip-container').removeClass('hidden');
    } else {
        $(event.target).siblings('.tooltip-container').addClass('hidden');
    }
});

